import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';

const AuthCallback = ({ setUser }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    handleAuthCallback();
  }, []);

  const handleAuthCallback = async () => {
    try {
      // Get session_id from URL fragment
      const fragment = location.hash.substring(1);
      const params = new URLSearchParams(fragment);
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error('Authentication failed');
        navigate('/');
        return;
      }

      // Exchange session_id for session token
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/auth/session`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        }
      );

      if (response.ok) {
        const data = await response.json();
        
        // Set session cookie
        document.cookie = `session_token=${data.session_token}; path=/; max-age=604800; SameSite=None; Secure`;
        
        setUser(data.user);
        toast.success(`Welcome, ${data.user.name}!`);
        
        // Clean URL and redirect
        window.history.replaceState({}, document.title, '/decisions');
        navigate('/decisions');
      } else {
        toast.error('Authentication failed');
        navigate('/');
      }
    } catch (error) {
      console.error('Auth error:', error);
      toast.error('Something went wrong');
      navigate('/');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="loading-spinner mx-auto mb-4"></div>
        <p className="text-gray-600">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
